module.exports = __webpack_public_path__ + "img/702_1.11087776.jpg";